import cn from "mcn";

export type AnchorPosition = { bottom: number; left: number };

export const textBase = "text-[length:var(--font-size-base,12px)] leading-[var(--line-height-text-base,18px)]";
export const textSm = "text-[length:var(--font-size-sm,10.5px)] leading-[var(--line-height-text-sm,15px)]";
export const textLg = "text-[length:var(--font-size-lg,13.5px)] leading-[var(--line-height-text-lg,21px)]";

export const cardShadow =
  "shadow-[0_10px_15px_-3px_var(--shadow-md,rgba(100,100,100,0.1)),0_4px_6px_-2px_var(--shadow-sm,rgba(100,100,100,0.06))]";

export const cardContainer = cn(
  "bg-[var(--card-default,white)] border border-[var(--outline-default,#bbb)]",
  "rounded-[var(--border-radius-rounded-lg,6px)]",
  cardShadow,
);

export const controlContainer = cn(
  "bg-[var(--card-default,white)] border border-[var(--outline-default,#bbb)]",
  "rounded-[var(--border-radius-rounded-lg,6px)] flex items-center",
  "gap-[var(--spacing-scale-small-200,6px)] shrink-0",
);
